import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
// import FacebookLogin from "react-facebook-login";

import toast from "react-hot-toast";
import { setUser } from "store/auth/authSlice";
import usePageMeta from "hooks/usePageMeta";
// import { REACT_APP_FACEBOOK_APP_ID } from "config";

const Login = () => {
  const dispatch = useDispatch();

  usePageMeta(
    "Sign In to Ubay | Transform the World Through Revealed Knowledge",
    "Sign in to Ubay.pk and join thousands of Muslims growing spiritually with one Quranic question every day. Free, non-profit, Pakistan.",
    "/"
  );

  const googleLoginSuccess = (response) => {
    toast.promise(
      axios
        .post("/auth/google-login", { credential: response.credential })
        .then((res) => {
          console.log(res.data);
          dispatch(setUser({ token: res.data.token, ...res.data.user }));
        }),
      {
        loading: "Logging you in...",
        success: <b>Login Successful</b>,
        error: <b>Could not Login</b>,
      }
    );
  };

  const googleLoginFailure = (err) => {
    toast.error("Uh Oh! Something went wrong");
    console.log(err);
  };

  // const facebookSuccess = (response) => {
  // console.log(response);
  // setIsLoading(true);
  // axios
  //   .post("/auth/facebook-login", {
  //     accessToken: response.accessToken,
  //     userID: response.userID,
  //   })
  //   .then((res) => {
  //     dispatch(setUser({ token: res.data.token, ...res.data.user }));
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //     toast.error("Uh Oh! Something went wrong");
  //   })
  //   .finally(() => {
  //     setIsLoading(false);
  //   });
  // };

  // const facebookFailure = (err) => {
  // console.log(err);
  // toast.error("Uh Oh! Something went wrong");
  // setIsLoading(false);
  // };

  return (
    <main className="h-screen flex flex-col lg:flex-row overflow-hidden">

      {/* ─── Left Column: Login Form ─── */}
      <div className="flex-1 relative flex flex-col h-screen overflow-y-auto">

        {/* Full-screen bg.jpg background */}
        <img src="/assets/imgs/bg.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />

        {/* Decorative Islamic geometric pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Ccircle cx='40' cy='40' r='16' stroke='%23d4af37' stroke-width='.5' fill='none' opacity='.4'/%3E%3Ccircle cx='0' cy='0' r='16' stroke='%23d4af37' stroke-width='.5' fill='none' opacity='.4'/%3E%3Ccircle cx='80' cy='0' r='16' stroke='%23d4af37' stroke-width='.5' fill='none' opacity='.4'/%3E%3Ccircle cx='0' cy='80' r='16' stroke='%23d4af37' stroke-width='.5' fill='none' opacity='.4'/%3E%3Ccircle cx='80' cy='80' r='16' stroke='%23d4af37' stroke-width='.5' fill='none' opacity='.4'/%3E%3C/svg%3E")`,
          }}
        />

        {/* Centered content */}
        <div className="flex-1 flex items-center justify-center px-4 sm:px-8 py-6 relative z-10">
          <div className="w-full max-w-lg">

            {/* ── Glass Card ── */}
            <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-3xl p-6 sm:p-8 shadow-2xl shadow-black/10">

              {/* Logo + Title */}
              <div className="text-center mb-6">
                <div className="inline-block p-2.5 rounded-2xl bg-white/60  mb-4 ring-1 ring-emerald-200/30">
                  {/* <img
                    className="h-16 w-auto sm:h-24 object-contain drop-shadow-lg"
                    src="/assets/imgs/UbayNewLogo.png"
                    alt="Ubay logo"
                  /> */}
                    <img
                    className="h-16 w-auto sm:h-24 object-contain "
                    src="/assets/imgs/UbayNewLogo.png"
                    alt="Ubay logo"
                  />
                </div>
                <p className="text-emerald-800 font-semibold text-sm sm:text-base mb-1.5 font-amiri">
                  بسم الله الرحمن الرحيم
                </p>
                <h1 className="text-slate-900 font-extrabold text-2xl sm:text-3xl tracking-tight">
                  Ubay<span style={{ color: '#14412d' }}>.pk</span>
                </h1>
                <p className="text-slate-500 text-xs sm:text-sm mt-1 tracking-wide">Thoughtful Quranic Question Daily</p>
              </div>

              {/* Sign-In Box */}
              <div className="bg-emerald-50/80 border border-emerald-200/50 rounded-2xl p-4 sm:p-5 mb-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 rounded-lg bg-emerald-100 flex items-center justify-center">
                    <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                  </div>
                  <h2 className="font-semibold text-slate-800 text-sm">Sign In</h2>
                </div>
                <p className="text-slate-500 text-xs mb-4">
                  Use your primary email so we can reach you if needed.
                </p>
                <div className="flex justify-center" id="auth-btns">
                  <GoogleLogin
                    useOneTap
                    buttonText={"Login with Google"}
                    onSuccess={googleLoginSuccess}
                    onFailure={googleLoginFailure}
                  />
                </div>
              </div>

              {/* Info Cards */}
              <div className="space-y-2.5 mb-5">
                <div className="flex gap-2.5 items-start">
                  <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-emerald-100 border border-emerald-200/50 flex items-center justify-center">
                    <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <p className="text-slate-700 text-xs sm:text-sm leading-relaxed pt-1">
                    One question posted daily. Registered members answer once per day.
                  </p>
                </div>

                <div className="flex gap-2.5 items-start">
                  <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-amber-100 border border-amber-200/50 flex items-center justify-center">
                    <svg className="w-3.5 h-3.5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                    </svg>
                  </div>
                  <p className="text-slate-700 text-xs sm:text-sm leading-relaxed pt-1">
                    Correct answers enter a periodic gift ballot.
                  </p>
                </div>
              </div>

              {/* Urdu Section */}
              <div data-nosnippet className="bg-emerald-50/60 border border-emerald-200/40 rounded-xl p-3 mb-4">
                <p dir="rtl" lang="ur" className="text-right text-slate-700 text-xs leading-loose">
                  Ubay.pk ایک اسلامی پلیٹ فارم ہے جہاں ہر روز ایک سوال پوسٹ کیا جاتا ہے۔ رجسٹرڈ ممبران روزانہ ایک بار سوال کا جواب دے سکتے ہیں۔ درست جواب دینے والے اراکین کو بیلٹ کے ذریعے تحفہ ملے گا۔
                </p>
              </div>

              {/* Service Notice + Contact row */}
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1 flex gap-2 items-center bg-amber-50/80 border border-amber-200/50 rounded-xl p-3">
                  <svg className="w-4 h-4 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  <p className="text-amber-800 text-xs">Operating in Pakistan only</p>
                </div>
                <div className="flex-1 flex gap-2 items-center bg-slate-50/80 border border-slate-200/50 rounded-xl p-3">
                  <svg className="w-4 h-4 text-emerald-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a className="text-slate-600 text-xs hover:text-emerald-700 transition-colors underline decoration-slate-300" href="mailto:ubayplatform@gmail.com">
                    ubayplatform@gmail.com
                  </a>
                </div>
              </div>

            </div>

            {/* Footer Links */}
            <footer className="mt-5 text-center text-xs text-slate-400 space-x-3">
              <Link className="hover:text-emerald-700 transition-colors" to="/about">About</Link>
              <span>•</span>
              <Link className="hover:text-emerald-700 transition-colors" to="/privacy">Privacy</Link>
              <span>•</span>
              <Link className="hover:text-emerald-700 transition-colors" to="/terms">Terms</Link>
              <span>•</span>
              <Link className="hover:text-emerald-700 transition-colors" to="/contact">Contact</Link>
            </footer>
          </div>
        </div>
      </div>

      {/* ─── Right Column: Quran Image (fixed to viewport) ─── */}
      <div className="hidden lg:block lg:w-[38%] xl:w-[40%] relative h-screen flex-shrink-0">
        <img
          src="/assets/imgs/UbayLandscapeBg.jpg"
          alt="Holy Quran"
          className="absolute inset-0 h-full w-full object-cover"
        />


        {/* Text overlay at bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-8 xl:p-10">
          <div className="max-w-sm">
            <div className="w-10 h-0.5 bg-emerald-500 rounded-full mb-4" />
            <h2 className="text-slate-800 text-xl xl:text-2xl font-bold leading-snug mb-2 drop-shadow-sm">
              Transform the World Through Revealed Knowledge
            </h2>
            <p className="text-slate-600 text-sm leading-relaxed drop-shadow-sm">
              Join thousands of Muslims growing spiritually with one Quranic question every day.
            </p>
          </div>
        </div>
      </div>

    </main>
  );
};

export default Login;
